var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"tipp",attrs:{"bottom":_vm.bottom,"top":_vm.top,"left":_vm.left,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("mdi-information")])]}}])},[_c('div',{staticClass:"max-width-tipp"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }